export const keepAlive = {
    "templatedetail": ["templaterecord"],
    "cases": ["search", "searchresult", "favorites", "casesDetail"],
    "searchstore": ["appointmentinfo"],
    "appointmentRecord": ["productDetail", "casesDetail", "appointmentBrowse", "appointmentDetail", "appointmentCode", "appointmentBrowse"],
    "appointment": ["searchstore"]
};

export const toLoginPages = [
    "templaterecord",
    "favorites",
    "appointment",
    "appointmentCode",
    "calculator",
    "appointmentRecord"
]


// WEBPACK FOOTER //
// ./src/constant.js